var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.18 55.997V51.627C47.1803 49.7477 46.8103 47.8868 46.0913 46.1505C45.3722 44.4142 44.3181 42.8366 42.9893 41.5077C41.6604 40.1789 40.0828 39.1248 38.3465 38.4058C36.6102 37.6867 34.7493 37.3167 32.87 37.317H31.13C29.2507 37.3167 27.3898 37.6867 25.6535 38.4058C23.9172 39.1248 22.3396 40.1789 21.0107 41.5077C19.6819 42.8366 18.6278 44.4142 17.9087 46.1505C17.1897 47.8868 16.8197 49.7477 16.82 51.627V55.997",
    stroke: "#426AB2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.003 37.317C37.1624 37.317 41.345 33.1344 41.345 27.975C41.345 22.8156 37.1624 18.633 32.003 18.633C26.8436 18.633 22.661 22.8156 22.661 27.975C22.661 33.1344 26.8436 37.317 32.003 37.317Z",
    stroke: "#426AB2",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.003 7.99699H12.003C10.9421 7.99699 9.92472 8.41842 9.17457 9.16857C8.42443 9.91871 8.003 10.9361 8.003 11.997V51.997C8.003 53.0579 8.42443 54.0753 9.17457 54.8254C9.92472 55.5756 10.9421 55.997 12.003 55.997H52.003C53.0639 55.997 54.0813 55.5756 54.8314 54.8254C55.5816 54.0753 56.003 53.0579 56.003 51.997V11.997C56.003 10.9361 55.5816 9.91871 54.8314 9.16857C54.0813 8.41842 53.0639 7.99699 52.003 7.99699V7.99699Z",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_1955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSvgrepoCom);
export default __webpack_public_path__ + "static/media/profile-svgrepo-com.0fd82f12c2091b0347744e3be83d6c44.svg";
export { ForwardRef as ReactComponent };